export default {
  viewType: 'calculator',
  breadcrumb: {
    title: '',
    action: '',
    class: ''
  },
  params: {}
}
